<template>
  <v-app-bar class="desktop-header" color="white" height="175px" flat tile>
    <v-sheet
      class="d-flex align-center"
      color="#F2F0F0"
      width="100%"
      height="45px"
    >
      <v-container class="d-flex align-center justify-end py-0">
        <div class="d-flex">
          <v-btn
            v-for="{ link, text, icon, size } in social"
            :key="text"
            color="transparent"
            :href="link"
            target="_blank"
            :title="text"
            depressed
            small
            fab
          >
            <v-icon color="primary" :size="size"> {{ icon }} </v-icon>
          </v-btn>
        </div>

        <v-sheet class="ml-4" width="245px">
          <SearchField />
        </v-sheet>
      </v-container>
    </v-sheet>

    <v-sheet class="d-flex align-center" width="100%" height="130px">
      <v-container class="py-0">
        <v-sheet
          width="100%"
          height="100%"
          color="transparent"
          class="d-flex justify-space-between align-center"
        >
          <router-link to="/">
            <img
              v-if="informations.img"
              :src="files + informations.img"
              :alt="informations.name"
              class="d-block"
              height="97px"
            />
          </router-link>

          <div class="d-flex align-center">
            <div>
              <div
                v-for="({ text, to }, keyMenu) in menu"
                :key="keyMenu"
                class="d-inline-flex"
              >
                <v-btn
                  class="
                    primary--text
                    text-caption text-lg-body-1 text-none text-uppercase
                    px-2 px-lg-3
                    py-4
                    nav-link
                  "
                  active-class="nav-link-active"
                  depressed
                  :to="to"
                  tile
                  text
                >
                  <span class="py-1 item">
                    {{ text }}
                  </span>
                </v-btn>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-container>
    </v-sheet>
  </v-app-bar>
</template>

<script>
import SearchField from "../../forms/fields/SearchField.vue";
import { menu } from "../../../config";
import { getSocial } from "../../../utils/getSocial";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  components: {
    SearchField,
  },
};
</script>

<style lang="scss" scoped>
.desktop-header::v-deep {
  .v-toolbar__content {
    flex-direction: column;
    padding: 0;
  }
}

.nav-link::v-deep {
  font-weight: 400 !important;

  &:before {
    opacity: 0 !important;
  }

  .item {
    border-bottom: 2px solid transparent !important;
  }

  &.nav-link-active {
    font-weight: 600 !important;

    .item {
      border-bottom: 2px solid var(--v-primary-base) !important;
    }
  }
}
</style>
